<div class="select-list {{selectedType}}" [attr.data-test]="formCtrlName||'select'"  >
    <ul>
      <li *ngFor="let option of options" [attr.data-test]="option"  [class.active]="checkActive(option.name)" (click)="change(option)">
        <fa-icon class="check" [icon]="icons.check"></fa-icon>
        <span>{{option.name }}</span>
      </li>
    </ul>
  </div>